<template>
  <b-modal id="cancel-modal" hide-footer title="Hủy ca" centered no-close-on-backdrop @hidden="resetDate">
    <p>Tải ảnh chụp màn hình phòng zoom phút thứ 15 để tiến hành hủy ca.</p>
    <button type="button" class="btn btn-warning" style="color: black" @click="openDirection()"
            :disabled="!!previewImage">
      <i class="el-icon-upload2" style="color: black; font-size: 15px"></i>Tải
      lên
    </button>
    <input
        ref="input"
        type="file"
        style="display:none"
        accept="image/*"
        @change="handleFileChange"
    />
    <div v-if="previewImage" style="width: 200px; height: 150px; position: relative" class="mt-4">
      <img :src="previewImage" alt="" style="width: 100%; height: 100%; object-fit: cover">
      <i @click="handleDeleteImage" class="el-icon-circle-close delete"
         style="position: absolute; top: -13px; right: -12px; cursor: pointer;font-size: 25px"></i>
      <div class="w-100 h-100 edit"
           style="position: absolute;top: 0; display: flex; justify-content: center; align-items: center">
        <i @click="openDirection" class="el-icon-edit icon-edit"></i>
      </div>
    </div>
    <p style="color: red" class="mt-4">Sau khi ca gia sư bị hủy, không thể vào dạy lại được.</p>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary mr-4" @click="closeModal()">Đóng</button>
      <button type="button" class="btn btn-danger" :disabled="!this.file || loading" @click="cancelTask" ><i v-if="loading" class="el-icon-loading"></i>Hủy ca</button>
    </div>
  </b-modal>
</template>
<script>
import {CANCEL_DETAIL_TUTOR_TASK} from "@/core/services/store/tutor/tutor.module";

export default {
  name: "CancelModal",
  data() {
    return {
      file: null,
      previewImage: null,
      loading: false
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('cancel-modal')
    },
    openDirection() {
      this.$refs.input && this.$refs.input.click();
    },
    handleFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.file = files[0];
      this.previewImage = URL.createObjectURL(files[0]);
      e.target.value = "";
    },
    handleDeleteImage() {
      this.file = null;
      this.previewImage = null;
    },
    resetDate() {
      this.file = null;
      this.previewImage = null;
      this.loading = false;
    },
    async cancelTask() {
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append('file', this.file);
        let payload = {
          idTask: this.$route.params.id,
          formData
        }
        await this.$store.dispatch(CANCEL_DETAIL_TUTOR_TASK, payload)
        await this.closeModal()
        this.$notify({
          title: 'Success',
          message: 'Hủy ca học thành công',
          type: 'success'
        });
        this.$emit('loadDetail')
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Đã có lỗi xẩy ra'
        });
      } finally {
        this.loading = false;
      }

    }
  },
  beforeDestroy() {
    if (this.previewImage) {
      URL.revokeObjectURL(this.previewImage);
    }
  }
}
</script>
<style scoped>
.delete:hover {
  color: red;
}

.delete {
  color: #0BACFB
}

.edit {
  background-color: rgba(153, 153, 153, 0); /* ban đầu trong suốt */
  transition: background-color 0.3s;
}

.edit:hover {
  background-color: rgba(153, 153, 153, 0.5); /* xám mờ 50% */
}

.icon-edit {
  display: none;
  color: #0BACFB;
  font-size: 25px;
}

.edit:hover .icon-edit {
  display: block;
  cursor: pointer;
}
</style>